<template>
  <vx-card title="Import NOO">
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>File</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <input
          class="inputx"
          type="file"
          v-if="uploadReady"
          ref="file"
          name="file"
          accept=".xlsx,.xls"
        />
      </div>
    </div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center"></div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-button class="ml-auto mt-2" v-on:click="handleSubmit" v-if="this.$store.getters['user/hasPermissions']('create')">Submit</vs-button>
      </div>
    </div>

    <div class="vx-row mb-12">
      <div v-bind:class="[detail ? detailShow : '', detailHide]">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ this.table.start }} - {{ this.table.end }} of
                  {{ this.table.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th>No</vs-th>
            <!-- <vs-th>Description</vs-th> -->
            <vs-th sort-key="file">File</vs-th>
            <vs-th sort-key="date">Date</vs-th>
            <vs-th sort-key="craeted_by">Created By</vs-th>
            <vs-th>Detail</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>{{ indextr + 1 }}</vs-td>
              <vs-td :data="data[indextr].file">
                <!-- <a
                  href="#"
                  v-on:click="downloadFileAwsS3(data[indextr].path)"
                  >{{ tr.file_name }}</a
                > -->
                <a :href="data[indextr].file_path" target="_blank">Download File</a>
              </vs-td>
              <vs-td :data="data[indextr].created_at">{{
                dateFormat(data[indextr].created_at)
              }}</vs-td>
              <vs-td>{{ tr.created_by }}</vs-td>
              <vs-td>
                <!-- <label>
                  <feather-icon
                    icon="CheckSquareIcon"
                    svgClasses="h-4 w-4"
                    style=""
                    class="ml-1"
                  />{{ data[indextr].document_success }}
                </label>
                <feather-icon
                  icon="XSquareIcon"
                  svgClasses="h-4 w-4"
                  class="ml-1"
                />
                {{ data[indextr].document_failed }}
                <br /> -->
                <a
                  ><vs-button
                    class="mt-2 ml-2"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                    v-on:click="showDetail(indextr, tr)"
                  ></vs-button
                ></a>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
    </div>
    <vs-popup fullscreen title="Log Details" :active.sync="detail">
      <div class="vx-row mb-6">
        <div class="vx-col w-full" v-if="detail">
          <datatableDetail :selected="selected"></datatableDetail>
        </div>
      </div>
    </vs-popup>
  </vx-card>
</template>
<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import datatableDetail from "./datatable-detail.vue";
export default {
  components: {
    Datepicker,
    datatableDetail,
  },
  data() {
    return {
      uploadReady: true,
      status_submit: false,
      detail: false,
      detailShow: "core vx-col md:w-1/1 w-full mb-base",
      detailHide: "core vx-col md:w-1/1 w-full mb-base",
      selected: {},
      posting_date: new Date(),
      table: {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      },
    };
  },
  methods: {
    nameWithCode({ Name, Code }) {
      return `${Code} - ${Name}`;
    },
    dateFormat(val) {
      return moment(val)
        .add(-7, "h")
        .utc()
        .local()
        .format("DD MMM YYYY HH:mm:ss");
    },
    handleSubmit() {
      this.$vs.loading();
      var file = this.$refs.file.files[0];
      if (file == null) {
        this.$vs.notify({
          color: "danger",
          title: "Form Validation",
          text: "File is required",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        this.getData();
      } else {
        this.uploadReady = false;
        this.$nextTick(() => {
          this.uploadReady = true;
        });
        this.formData = new FormData();
        this.formData.append("user_agent", navigator.userAgent);
        this.formData.append("file", file);
        this.$http
          .post("/api/sfa/v1/import/customer-noo", this.formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((resp) => {
            if (resp.code == 200) {
              var message = "";
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
              this.getData();
            } else {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: resp.message,
                position: "top-right",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
              this.getData();
            }
          })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: error,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.getData();
          });
      }
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    closeDetail() {
      this.detail = false;
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    showDetail(index, data) {
      this.selected = data.id;
      this.detail = true;
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/import/log/customer-noo", {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
            type: "import-noo-from-sap",
          },
        })
        .then((resp) => {
          if (resp.status == "OK") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            console.log(resp.data.records)
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            console.log(resp.message);
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
  },
  mounted() {
    this.$store.dispatch("user/getPermissions", "import-customer-noo-from-sap");
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
  watch: {},
};
</script>
<style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}

.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.core-enter,
.core-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}

.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}

.highlight > td {
  background-color: #d0cdf0;
}

.con-vs-checkbox {
  margin-left: auto;
  margin-right: auto;
}

.nonfixed {
  position: inherit;
  padding-left: 20px;
}

.core {
  -webkit-transform-origin-y: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}

.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}
.colored {
  border: 1px solid #7367f0;
  position: fixed;
  left: 4%;
  top: 40%;
  max-width: 45%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}
</style>